import React, { Component } from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";

import { MAP_HERO_ID_CN } from "@/utils/getting";
import Store from "@/stores";

class RecordList extends Component {
	static propTypes = {
		list: PropTypes.array,
		title: PropTypes.string
	}
	static defaultProps = {
		list: [],
		title: ""
	}
	render() {
		const { title, list } = this.props;
		const map = list && list.length
			? list.map(v => <li key={v.mysticType}>• {MAP_HERO_ID_CN[v.mysticType]}：<span>{v.mysticTier}</span></li>)
			: null;
		return (
			<div className="ladder-record-list">
				<h3>{title}</h3>
				<ul>{map}</ul>
			</div>
		);
	}
}

@observer
class Record extends Component {
	static propTypes = { _ladderStore: PropTypes.object }
	static defaultProps = { _ladderStore: {} }
	render() {
		const { normal, normalHard, season, seasonHard } = Store._ladderStore.record;
		return (
			<div className="ladder-record">
				<RecordList title="赛季模式单人榜世界纪录" list={season} />
				<RecordList title="赛季专家模式单人榜世界纪录" list={seasonHard} />
				<RecordList title="普通模式单人榜世界纪录" list={normal} />
				<RecordList title="专家模式单人榜世界纪录" list={normalHard} />
			</div>
		);
	}
}
export default Record;